$(window).on('load hashchange',function(){
    $('.scale-up-center').removeClass('scale-up-center');
    let hash =  location.hash.slice(1);
    if (hash) {
        $(`#${hash}`).addClass('scale-up-center');
    }

	//  ハッシュのIDを持つタグへ、animateでスクロールして移動
	setTimeout(function(){
		var target = $(`#${hash}`);
		var position = target.offset().top - 150;
		$('body,html').stop().animate({scrollTop:position}, 500);
	}, 100);
});
